import React from 'react';

/**
 * Etiqueta — classificação livre com uma das 8 cores fixas. Não indica situação.
 * cor: 'azul' | 'cinza' | 'laranja' | 'marrom' | 'petroleo' | 'rosa' | 'roxo' | 'verde'
 */
export default function Etiqueta({ cor = 'cinza', children }) {
  return (
    <span className={`sj-etiqueta sj-etiqueta--${cor}`}>
      <span className="sj-etiqueta__ponto" aria-hidden="true" />
      {children}
    </span>
  );
}
